import { Permissions } from '@api/apiClient';
import { jwtDecode } from 'jwt-decode';

// Add to the global window object for auto-completion in the console
// > window.UserPermissionStore
export { };
declare global {
  interface Window {
    UserPermissionStore: UserPermissionStore;
  }
}

interface JwtPayload {
  email: string;
  role: string | string[] | undefined;
  permission: string | string[] | undefined;
  expiresIn: number;
  nbf: number;
  exp: number;
  iat: number;
}

interface UserPermission {
  email: string;
  roles: string[];
  permissions: string[];
  expiresIn: number;
}

class UserPermissionStore {
  public userPermission: UserPermission | null = null;
  public primaryRole: string | undefined = undefined;
  private resourcePermission: string[] = []; // Store the app store instance

  constructor() {
    window.UserPermissionStore = this;
    //makeAutoObservable(this, {}, { autoBind: true });
  };

  setPermission = (jwtToken: string) => {
    if (jwtToken) {
      const decodedToken = jwtDecode<JwtPayload>(jwtToken);
      this.userPermission = {
        email: decodedToken?.email,
        roles: this.toArray(decodedToken?.role),
        permissions: this.toArray(decodedToken?.permission),
        expiresIn: decodedToken?.expiresIn || 0,
      };

      this.primaryRole = this.userPermission?.roles[0];
    }
    else {
      this.userPermission = null;
    }
  };

  toArray = (input: string | string[] | undefined) => {
    if (Array.isArray(input)) {
      return input;
    } else if (input) {
      return [input];
    }
    return [];
  };

  hasPermissionForDashBoard = (permission: string, projectPermissions: string[] = []) => {
    // According to jude a user having ICT admin should have all permission even if assigned project has other permission set

    // check if user is admin 
    const hasManagePermission = this.userPermission?.permissions.some(p => p.includes(Permissions.App_Manage.toLowerCase()));
    if (hasManagePermission) {
      return hasManagePermission;
    }

    // check if user has manage permission in project
    const hasProjectManagePermission = projectPermissions.some(p => p.includes(Permissions.App_Manage.toLowerCase()));
    if (hasProjectManagePermission) {
      return hasProjectManagePermission;
    }

    const hasSpecificPermission = projectPermissions.includes(permission?.toLowerCase());

    return hasSpecificPermission;
  };

  hasPermission = (permission: string) => {
    // According to jude a user having ICT admin should have all permission even if assigned project has other permission set
    const hasManagePermission = this.userPermission?.permissions.some(p => p.includes(Permissions.App_Manage.toLowerCase()));
    if (hasManagePermission) {
      return hasManagePermission;
    }

    // check if user has manage permission in project
    const hasProjectManagePermission = this.resourcePermission.some(p => p.includes(Permissions.App_Manage.toLowerCase()));
    if (hasProjectManagePermission) {
      return hasProjectManagePermission;
    }

    const hasSpecificPermission = this.resourcePermission.includes(permission?.toLowerCase());

    return hasSpecificPermission;

  };

  setResourcePermissions = (permissions?: string[]) => {
    this.resourcePermission = permissions ?? [];
  };
}

export default UserPermissionStore;
